import React, { useEffect } from "react";
import { Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";

const RoadTransport = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, [location.pathname]); // Triggers when the pathname changes
  const direction = "ltr";
  const textAlign = "left";
  return (
    <Box
      style={{ direction, textAlign }}
      sx={{
        padding: "20px",
        maxWidth: "1300px",
        margin: "auto",
        marginTop: "10px",
        "@media (min-width: 1024px)": {
          marginTop: "10px",
        },
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {"Road Transport"}
      </Typography>
      {/* Introduction Section */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.4rem",
          "@media (min-width: 1024px)": {
            fontSize: "1.2rem",
          },
        }}
      >
        {
          "At UK TO MARS, we specialize in reliable and efficient road transport services from the UK to Iraq, ensuring that your goods arrive safely and on time."
        }
      </Typography>

      {/* Why Choose Our Road Transport Service? */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {"Why Choose Our Road Transport Service?"}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[
          "Fast and Secure Delivery: We guarantee speedy delivery with the highest level of care for your cargo.",
          "Comprehensive Coverage: Our services cover both personal and commercial goods, offering tailored solutions for your needs.",
          "Flexible Options: Whether you have palletized goods or loose boxes, we have the expertise to handle it all.",
          "Regular Departures: With consistent schedules and a robust network, your shipments are never delayed.",
          "Expert Team: Our experienced team ensures smooth customs clearance at both the UK and Iraq borders.",
        ].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem",
                      lg: "1.4rem",
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Key Features of Our Road Transport Services */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {"Key Features of Our Road Transport Services:"}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[
          "Custom Solutions: From small groupage (LTL) shipments to full truckloads (FTL), we offer cost-effective solutions for businesses of all sizes.",
          "End-to-End Tracking: Stay informed with real-time updates on the progress of your shipment.",
          "Packaging Services: We handle packing and preparation to ensure your goods are secure for the journey.",
          "Customs Clearance: Comprehensive support for export declarations and border clearances to avoid delays.",
        ].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem", // Mobile
                      lg: "1.4rem", // Desktop
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Who Do We Serve? */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {"Who Do We Serve?"}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[
          "Businesses: Transporting goods to support trade between the UK and Iraq.",
          "Individuals: Sending personal items to loved ones or for relocation purposes.",
        ].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem", // Mobile
                      lg: "1.4rem", // Desktop
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Get in Touch */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {"Get in Touch"}
      </Typography>

      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.4rem",

          "@media (min-width: 1024px)": {
            fontSize: "1.4rem",
          },
        }}
      >
        {
          "Ready to ship your goods with confidence? Contact us today to discuss your road transport needs and get a customized quote."
        }
      </Typography>

      <ContactChat />
    </Box>
  );
};

export default RoadTransport;
